const typeOfProfile = [
  { label: "Verified", value: "Verified" },
  { label: "Premium", value: "Premium" },
];
export default typeOfProfile;
